import { usePermanentLocations } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient } from "hooks";
import { CarDetailsQueryKeys } from "modules/CarDetails/queryKeys";

import type { Car } from "models";

export const useCarLocation = (car?: Car) => {
  const { locations } = usePermanentLocations();

  const locationId = car ? car.dealer_location_id : typedQueryClient.getQueryData(CarDetailsQueryKeys.details)?.dealer_location_id;
  if (!locationId) return;

  return locations.find(location => location.id === locationId);
};
